import { api, apiFile, base_url_v1, base_url_v2 } from "./api";



export const PlanListApi = async () => {
    const data = await api({ url: `${base_url_v2}company/get-plans`, method: "GET", token: true })
    return data;
}

export const BuyPanelApi = async (selectedPanel: any , discount:any) => {
    let postData:any = {
        'plan_id': selectedPanel.id,
        'return_page': 'https://dayan-web.vercel.app/p/plan-result',
    }
    if(discount.amount != 0){
        postData['discount_code'] = discount.code ;
    }
    const data = await api({ url: `${base_url_v2}company/make-payment`, method: "POST", token: true, body: JSON.stringify(postData) })
    return data;
}


export const CheckDiscountApi = async (selectedPanel:any , formRef:any) => {
    let postData = JSON.stringify({
        'amount': selectedPanel.amount,
        'code':formRef.current['discount'].value ,
    })
    const data = await api({ url: `${base_url_v2}company/discount`, method: "POST", token: true, body: postData })
    return data;
}

